import { CapacitorConfig } from '@capacitor/cli';

const config: CapacitorConfig = {
  appId: 'com.catalinasoftware.freedom.gox',
  appName: 'FreedomGoX',
  webDir: 'dist',
  ios: {
    appendUserAgent: 'ios:application',
  },
  android: {},
  server: {
    hostname: 'com.catalinasoftware.freedom.gox',
  },
  plugins: {
    SplashScreen: {
      launchAutoHide: false,
      launchFadeOutDuration: 500,
      showSpinner: false,
    },
  },
};

export default config;
